import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { render } from "preact";

import "./styles/base.css";
import "./styles/app.css";

import { App } from "./app";
import { ToastProvider } from "./components/ui";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => !(error instanceof Error && "status" in error && error.status === 401) && count < 2,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});

const root = document.getElementById("app");
if (!root) throw new Error("Missing #app root");

render(
  <QueryClientProvider client={queryClient}>
    <ToastProvider><App queryClient={queryClient} /></ToastProvider>
  </QueryClientProvider>,
  root,
);
